import axios from 'axios'
import { env } from '@/config/env'
import { attachInterceptors } from './interceptors'

/**
 * HTTP client for brushfire-platform-service (team, instruments, …).
 * Default empty baseURL + Vite proxy keeps cookies on the dev origin so
 * identity's `access_token` cookie is forwarded to platform.
 */
export const platformClient = axios.create({
  baseURL: env.VITE_PLATFORM_API_BASE_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
})

attachInterceptors(platformClient)
